import { Content } from 'components/Layout';
import PublicNavbar from 'components/navbars/publicNavbar';
import React, { useEffect } from 'react';
import { scrollTop } from 'utils/funciones';
import Piepagina from './FooterHomePublica';

const HomePublica = ({ children }) => {
  useEffect(() => {
    scrollTop();
  }, []);

  return (
    <React.Fragment>
      <Content fluid>
        <PublicNavbar />
        {children}
        <Piepagina />
      </Content>
    </React.Fragment>
  );
};

export default HomePublica;
